import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: ISalesCreated = (() => {
  if (typeof window !== "undefined") {
    // Ensure we're on client side
    const persistedState = localStorage.getItem("__redux__sales__");
    if (persistedState !== null) {
      return JSON.parse(persistedState);
    } else {
      return {
        total: {
          total: 0,
          payments: 0,
          delivery: 0,
        },
        status: "",
        sell_type: "",
        productsList: [] as IProductList[],
        CDC: "",
        id_sell: 0,
        id_image: 0,
        id_payment_type: 0,
      };
    }
  } else {
    return {
      total: {
        total: 0,
        payments: 0,
        delivery: 0,
      },
      status: "",

      sell_type: "",
      productsList: [] as IProductList[],
      CDC: "",
      id_sell: 0,
      id_image: 0,
      id_payment_type: 0,
    };
  }
})();

const saleSlice = createSlice({
  name: "sale",
  initialState,
  reducers: {
    createSale: (state, action: PayloadAction<ISalesCreated>) => {
      const { id_sell, productsList, total, status, sell_type, CDC } =
        action.payload;
      state.id_sell = id_sell;
      state.status = status;
      state.sell_type = sell_type;
      state.CDC = CDC;

      state.total = {
        total: total.total,
        payments: total.payments,
        delivery: total.delivery,
      };
      state.productsList = productsList.map((product) => {
        const { quantity, product_name, price, image_url, id_product } =
          product;
        return {
          quantity,
          product_name,
          price,
          image_url,
          id_product,
        };
      });
      const stateString = JSON.stringify(state);
      // Persistir en localStorage
      localStorage.setItem("__redux__sales__", stateString);
    },

    addSalesIdImage: (state, action: PayloadAction<{ id_image: number }>) => {
      const { id_image } = action.payload;
      state.id_image = id_image;
      // Persistir en localStorage
      const stateString = JSON.stringify(state);
      // Persistir en localStorage
      localStorage.setItem("__redux__sales__", stateString);
    },
    addSalesIdPayment: (
      state,
      action: PayloadAction<{ id_payment_type: number }>
    ) => {
      const { id_payment_type } = action.payload;
      state.id_payment_type = id_payment_type;
      // Persistir en localStorage
      const stateString = JSON.stringify(state);
      // Persistir en localStorage
      localStorage.setItem("__redux__sales__", stateString);
    },
    deleteSale: (state) => {
      localStorage.removeItem("__redux__sales__");
      state.id_sell = 0;
      state.status = "";
      state.sell_type = "";
      state.CDC = "";
      state.productsList = [];
      state.total = {
        total: 0,
        payments: 0,
        delivery: 0,
      };
      // Eliminar propiedades opcionales si existen
      delete state.id_image;
      delete state.id_payment_type;
      delete state.external_id;
    },
  },
});

export const { createSale, deleteSale, addSalesIdPayment, addSalesIdImage } =
  saleSlice.actions;
export default saleSlice.reducer;
